import { Outlet, useLocation } from 'react-router-dom';
import { CustomerPortalSidebar } from './CustomerPortalSidebar';
import { CustomerPortalHeader } from './CustomerPortalHeader';
import { CustomerPortalFooter } from './CustomerPortalFooter';
import { CustomerMobileNav } from './CustomerMobileNav';
import { CustomerPageContainer } from '@/components/customer-portal/CustomerPageContainer';

/**
 * Shell: fixed sidebar from `lg`, sticky header, scrolling main with the
 * footer inside the scroll area, and a bottom tab bar below `lg`. The main
 * area reserves space for that bar (`customer-pb-nav`) so sticky navigation
 * never covers the last card or the footer.
 */
export function CustomerPortalLayout() {
  const location = useLocation();

  return (
    <div className="flex h-screen overflow-hidden bg-customer-bg">
      <CustomerPortalSidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <CustomerPortalHeader />
        <div className="customer-pb-nav flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden lg:pb-0">
          <main className="flex-1 px-4 py-4 sm:px-6 sm:py-6">
            <CustomerPageContainer>
              {/* key forces a fresh mount per route so the entrance animation replays on navigation */}
              <div key={location.pathname} className="customer-fade-in">
                <Outlet />
              </div>
            </CustomerPageContainer>
          </main>
          <CustomerPortalFooter />
        </div>
        <CustomerMobileNav />
      </div>
    </div>
  );
}
